import { SELECT_TOURNAMENT, SET_TOURNAMENTS } from "../constants/tournaments";

const initialState = {
    tournaments:[],
    selectedTournament:'',
    loading:false
}

function tournaments(state = initialState, action) {
switch (action.type) {
    case SET_TOURNAMENTS:
        return {...state, tournaments: action?.payload };
    case SELECT_TOURNAMENT:
        return {...state, selectedTournament: action?.payload};
    default:
        return state;
}

}

export default tournaments